export default __webpack_public_path__ + "static/media/frame-students.66ed6d2a.png";